module.exports = __webpack_public_path__ + "img/salah.c89a9706.png";